import { useRef, useState } from "react";
import styled from "styled-components";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { LifeAtTextInputV2 } from "@common/LifeAtTextInput/LifeAtTextInputV2";
import { callMonolith } from "@service/ServerlessFunctionsService";
import Styles from "@themes/Styles";
import { reloadPage } from "@util/BrowserUtil";

const StyledInput = styled(LifeAtTextInputV2)`
    border: 1px solid ${({ theme }) => theme.borderPrimary};
    border-radius: ${Styles.borderRadiusSharp};
`;

type State = "ready" | "editing" | "loading";

type Props = {
    uid: string;
    currDailyStreak: number;
};

export function AdminStreakInput(props: Props) {
    const [state, setState] = useState<State>("ready");
    const ref = useRef<HTMLInputElement>(null);

    const handleCommit = async () => {
        setState("loading");
        const next = Number(ref.current?.value);
        await callMonolith("admin-set-streak", { uid: props.uid, currDailyStreak: next });
        reloadPage();
    };

    return (
        <>
            <span>Current streak</span>
            {state === "ready" ? (
                <span>{props.currDailyStreak}</span>
            ) : (
                <StyledInput disabled={state === "loading"} ref={ref} defaultValue={props.currDailyStreak} />
            )}
            {state === "ready" ? (
                <LifeAtButtonV2 fullWidth onClick={() => setState("editing")}>
                    Edit
                </LifeAtButtonV2>
            ) : (
                <LifeAtButtonV2 fullWidth isDisabled={state === "loading"} onClick={handleCommit}>
                    Save
                </LifeAtButtonV2>
            )}
        </>
    );
}
